import { HTMLChakraProps, forwardRef } from '@chakra-ui/react-v2';
import { chakra } from '@chakra-ui/react-v2';

import { Badge } from '@frontend/legacy-components';

import { useActionPreviewContext } from '../ActionPreviewContext';
import { useActionPreviewStyles } from '../useActionPreviewStyles';

export type ActionPreviewBadgeProps = Omit<HTMLChakraProps<'div'>, 'children'>;

export const ActionPreviewBadge: React.FC<ActionPreviewBadgeProps> = forwardRef<
  ActionPreviewBadgeProps,
  'div'
>(({ ...props }, ref) => {
  const { badge } = useActionPreviewStyles();
  const { mode } = useActionPreviewContext();

  // Only render badge for approved or rejected states
  if (mode === 'pending') {
    return null;
  }

  const badgeText = mode === 'approved' ? 'Approved' : 'Cancelled';
  const colorScheme = mode === 'approved' ? 'success' : 'error';

  return (
    <chakra.div
      sx={badge}
      className="action-preview-badge"
      {...props}
      ref={ref}
    >
      <Badge size="xs" colorScheme={colorScheme}>
        {badgeText}
      </Badge>
    </chakra.div>
  );
});
ActionPreviewBadge.displayName = 'ActionPreviewBadge';
